import React from "react";
import { useSelector } from "react-redux";
import { Button } from "@mui/material";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import { selectGameStage } from "../../store/selectors";
import { GameStage } from "../../types/types";
import { BidsLog } from "./GameDetails/BidsLog";
import { DeclarerDetails } from "./GameDetails/DeclarerDetails";
import { HandDetails } from "./GameDetails/HandDetails";
import { PartnerDetails } from "./GameDetails/PartnerDetails";
import { WonBidDetails } from "./GameDetails/WonBidDetails";
import { AnnouncementDetails } from "./GameDetails/AnnouncementDetails";
import { useCurrentUser } from "../../hooks/useCurrentUser";

export const GameDetails: React.FC = () => {
  const stage = useSelector(selectGameStage);
  const { setViewingScores } = useCurrentUser();

  return (
    <div className="p-4 bg-white/95 backdrop-blur rounded-xl shadow-lg flex-1 flex flex-col gap-4 border border-emerald-200">
      <h2 className="text-lg font-bold text-emerald-900 border-b border-emerald-100 pb-2">Game Info</h2>
      <HandDetails />
      <WonBidDetails />
      <DeclarerDetails />
      <PartnerDetails />
      <AnnouncementDetails />
      {stage === GameStage.Bidding && <BidsLog />}
      
      {/* View Scores Button */}
      <div className="mt-auto pt-4 border-t border-emerald-100">
        <Button
          variant="outlined"
          size="small"
          startIcon={<LeaderboardIcon />}
          onClick={() => setViewingScores(true)}
          sx={{
            width: '100%',
            color: '#059669',
            borderColor: '#059669',
            '&:hover': {
              borderColor: '#047857',
              backgroundColor: 'rgba(5, 150, 105, 0.04)',
            },
          }}
        >
          View Scores
        </Button>
      </div>
    </div>
  );
};
